import $ from 'jquery';
window.$ = window.jQuery = $;
import 'bootstrap';
import Swal from 'sweetalert2';
window.Swal = Swal;
$(document).on("click", ".itemAdd", function()
{
	let rate = $(this).data("price");
	let item = $(this).data("item");
	$.ajax(
	{
		headers: {
		'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
		},
		url: '/item/details',
		type: 'POST',
		data: {
			"_token": $("input[name='_token']").val(),
			"rate": rate,
			"item": item,
		},
		success: function(response)
		{
			$('#itemDetailsModal').html(response.html);
			window.$('#itemDetailsModal').modal('show');
		}
	});
	/*const modalInstance = new bootstrap.Modal($('#itemDetailsModal'));
	modalInstance.show();*/
	//$('#itemDetailsModal').modal("show");
	
});

$(document).ready(function() 
{
 	$('.js-example-basic-multiple').select2();
 	//$('.js-example-basic-multiple').multiselect();
});
$(document).on("click", ".minus", function()
{
	let item = $(this).data("item");
	let rate = $(this).data('rate');
	let $input = $(this).parent().find('input');
	let count = parseInt($input.val()) - 1;
	count = count < 0 ? 0 : count;
	$input.val(count);
	$input.change();
	if(count == 0)
	{
		$(".item-"+item).addClass("d-block");
		$(".item-"+item).removeClass("d-none");
		$(".qtyBtn-"+item).addClass("d-none");
		$(".qtyBtn-"+item).removeClass("d-block");
	}
	let amount = rate * count;
	$(".totalAmount").html(amount);
	$(".totalAmt").html(amount);
	$(".placeOrder").val("₹ "+amount+" Place Order");
	return false;
});
$(document).on("click", ".plus", function()
{
	let rate = $(this).data('rate');
	let $input = $(this).parent().find('input');
	let count = parseInt($input.val()) + 1;
	let amount = rate * count;
	$(".totalAmount").html(amount);
	$(".totalAmt").html(amount);
	$(".placeOrder").val("₹ "+amount+" Place Order");
	$input.val(count);
	$input.change();
	return false;

});

$(document).on("click", ".addToCart", function()
{
	let sessionVendor = $('#sessionVendor').val();
	let count = $('.totalItem').val();
	let vendorId = $('#vendorId').val();
	let amount = $(".totalAmt").html();
	$('.cartBtn').attr('data-item-id', $("#itemId").val());
	$('.cartBtn').attr('data-price', $(".totalAmt").html());
	$("#priceAmt").val(amount);
	$("#totalItem").val($("#itemId").val());
	$("#itemCnt").val(count);
	window.$('#itemDetailsModal').modal('hide');
	if(sessionVendor == vendorId)
	{
		let type = "exist";
		addCartFun(count, vendorId, amount, type)
	}
	else
	{
		if(confirm('Your cart contains dishes from other restaurant. Do you want to discard the selection and add dishes from current restaurant?'))
		{
			let type = "new";
			addCartFun(count, vendorId, amount, type)
		}
		else
		{
			removeCart(item);
			return false;
		}
	}
	
});

$(document).on("click", ".cartBtn", function()
{
	let vendor = $(".cartBtn").data('vendor-id');
	$("#vendor").val(vendor);
	$('#cartDetails').submit();
});

function updateButtonText() 
{
    $.ajax(
    {
        url: '/cart/session',
        type: 'GET',
        success: function(response) 
        {
        	if(response.totalQty != 0)
        	{
	            let text = response.totalQty + ' Items added &nbsp;&nbsp view Cart<br> Total Amount '+ response.grandTotal ;
	            $(".cartBtn").html(text);
	            $(".floatingButton").removeClass('d-none');
	            $(".floatingButton").addClass('d-block');
        	}
        	else
        	{
        		$(".floatingButton").addClass('d-none');
        		$(".floatingButton").removeClass('d-block');
        	}
        },
        error: function(xhr, status, error) 
        {
            console.error('Error checking session update:', error);
        }
    });
}
setInterval(updateButtonText, 5000);

function addCartFun(count, vendorId, amount, type,item)
{
	$.ajax(
	{
		headers: {
		'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
		},
		url: '/item/add',
		type: 'POST',
		data: {
			"_token": $("input[name='_token']").val(),
			"qty": count,
			"vendorId": vendorId,
			"amount": amount,
			"itemId": item,
			"type"  : type
		},
		success: function(response)	
		{
			let text = response.totalQty + ' Items added &nbsp;&nbsp view Cart<br> Total Amount '+ response.grandTotal ;
			$(".cartBtn").html(text);
			$(".floatingButton").removeClass('d-none');
			$(".floatingButton").addClass('d-block');
			$(".totalAmount-"+item).html(amount);
			$(".totalAmt").html(amount);
			$(".finalGrandTotal").html("<h5>" + "₹ "+ response.grandTotal + "</h5>");
			$(".finalCgst").html("<h5>" + "₹ "+ response.perAmount + "</h5>");
			$(".finalSgst").html("<h5>" + "₹ "+ response.perAmount + "</h5>");
			$(".finalPay").html("<h5>" + "₹ "+ response.payAmount + "</h5>");
			$(".placeOrder").val("₹ "+ response.payAmount +" Place Order");
			$('#sessionVendor').val(response.itemVendor);
		}
	});
}
$(document).on("click", ".addItem", function()
{
	let item = $(this).data("item");
	$(".item-"+item).addClass("d-none");
	$(".item-"+item).removeClass("d-block");
	$(".qtyBtn-"+item).addClass("d-block");
	$(".qtyBtn-"+item).removeClass("d-none");
});
$(document).on("click", ".addItem, .plus, .minus", function()
{
	let item = $(this).data("item");
	let price = $(this).data("price");
	let sessionVendor = $('#sessionVendor').val();
	let count = $('.totalItem-'+item).val();
	let vendorId = $('#vendorId').val();
	let amount = price * count;
	console.log(sessionVendor == '');
	if(sessionVendor == '')
	{
		let type = "new";
		addCartFun(count, vendorId, amount, type, item)
	}
	else if(sessionVendor == vendorId)
	{
		let type = "edit";
		addCartFun(count, vendorId, amount, type,item)
	}
	else
	{
		if(confirm('Your cart contains dishes from other restaurant. Do you want to discard the selection and add dishes from current restaurant?'))
		{
			let type = "new";
			addCartFun(count, vendorId, amount, type,item)
		}
		else
		{
			removeCart(item);
			return false;
		}
	}
});

$(document).on("change", "#selectVendor", function()
{
	let vendorId = $(this).val();
	$.ajax(
		{
			type:"get",
			url:  '/getCategories/'+vendorId,
			success:function(res)
			{
				console.log(res);
				if(res)
				{
					$("#selectCategory").empty();
					$("#selectCategory").append('<option>Select Category</option>');
					$.each(res,function(key,value)
					{
						$("#selectCategory").append('<option value="'+value+'">'+key+'</option>');
					});
				}
			}
		});
});

$(document).on("click", ".orderListDetails", function()
{
	let orderId = $(this).data('order');
	$.ajax(
	{
		headers: {
		'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
		},
		url: '/order/item/details',
		type: 'POST',
		data: {
			"_token": $("input[name='_token']").val(),
			"orderId": orderId,
		},
		success: function(response)
		{
			$('#orderItemModal').html(response.html);
			$('#orderItemModal').modal("show");
		}
	});
});

function removeCart(item)
{
	$(".item-"+item).addClass("d-block");
	$(".item-"+item).removeClass("d-none");
	$(".qtyBtn-"+item).addClass("d-none");
	$(".qtyBtn-"+item).removeClass("d-block");
}

$(document).on("change", "#orderStatus", function()
{
	let initialStatus = $(this).data('status');
	let status = $(this).val();
	let orderId = $(this).data('order-id');
	if(confirm("Are you sure you want to change the status?")) 
	{
		$.ajax(
	{
		headers: {
		'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
		},
    	url: "/order/status/update",
    	method: 'POST',
    	data: {
    	    status: status,
    	    orderId: orderId,
    	    "_token": $("input[name='_token']").val(),
    	},
    	success: function(response) 
    	{
    	    alert('Status updated successfully!');
    	    window.location.reload();
    	},
    	error: function(xhr, status, error) {
    	    console.error('Error updating status:', error);
    	}
    });
	}
	else 
	{
	    $(this).val(initialStatus);
	}
});
setInterval(function()
{
	$('#order-datatable').DataTable().ajax.reload(null, false);	
},60000);